module.exports = __webpack_public_path__ + "img/4-7-raiderettes.90fd9309.jpg";